// react documenation used: https://react.dev/learn
// ReactRouter documentation was used to help creade teh code from linesL 13, 17-36: https://reactrouter.com/web/guides/quick-start
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./navBar.module.css";

const NavBar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/loginPage");
  };

  return (
    <nav className={styles["navbar"]}>
      <div className={styles["navbar__logo"]}>
        <Link to="/homePage">
          <img src="/logo-greenBg.png" alt="RepoMerge" />
        </Link>
      </div>
      <div className={styles["navbar__sidebuttons"]}>
        <Link to="/searchPage" className={styles["navbar__logo"]}>
          <img src="/magnifying-glass.png" alt="Search" />
        </Link>
        <Link to="/homePage" className={styles["navbar__logo"]}>
          <img src="/home.png" alt="Home" />
        </Link>
        <Link to="/discoverPage" className={styles["navbar__logo"]}>
          <img src="/open-book.png" alt="Discover" />
        </Link>
        <Link to="/favouritesPage" className={styles["navbar__logo"]}>
          <img src="/favourite.png" alt="Favourites" />
        </Link>
        <Link to="/accountPage" className={styles["navbar__logo"]}>
          <img src="/user.png" alt="Account" />
        </Link>
        <div
          className={styles["navbar__logo"]}
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          <img src="/logout.png" alt="Logout" />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
